// Shows the resume at /resume. Amplify's SPA rewrite turns /Shan-Memon-Resume.pdf into the homepage
// (.pdf isn't in its pass-through list), so the build copies the PDF to a .pdf.json file (see
// "prebuild" in package.json), and this page loads those bytes and hands them to the browser's
// PDF viewer.
export const RESUME_PATH = /^\/resume\/?$/;
const FILE = '/Shan-Memon-Resume.pdf.json';
const NAME = 'Shan-Memon-Resume.pdf';

function el<K extends keyof HTMLElementTagNameMap>(tag: K, style: string, text = ''): HTMLElementTagNameMap[K] {
  const n = document.createElement(tag);
  n.setAttribute('style', style);
  n.textContent = text;
  return n;
}

const BTN = 'color:#fff;text-decoration:none;border:1px solid #fff;padding:6px 14px;font-size:15px;font-family:inherit';

export async function mountResume() {
  document.title = 'Shan Memon · Resume';
  const root = document.getElementById('root') as HTMLElement;
  document.body.style.cssText = 'margin:0;background:#121212';
  root.setAttribute('style', 'display:flex;flex-direction:column;height:100vh;height:100dvh');

  const bar = el('div', 'display:flex;align-items:center;gap:12px;padding:10px 16px;background:#121212;color:#fff;font-family:Centra,system-ui,sans-serif');
  const back = el('a', BTN, '← Portfolio');
  back.href = '/';
  bar.append(back, el('span', 'flex:1;font-size:17px;font-weight:600', 'Shan Memon · Resume'));
  const body = el('div', 'flex:1;display:flex;align-items:center;justify-content:center;color:#fff;font-family:system-ui,sans-serif', 'Loading resume…');
  root.replaceChildren(bar, body);

  try {
    const res = await fetch(FILE, { cache: 'no-cache' });
    const bytes = new Uint8Array(await res.arrayBuffer());
    // %PDF: anything else means the host served the homepage instead of the file.
    if (!res.ok || String.fromCharCode(...Array.from(bytes.slice(0, 4))) !== '%PDF') throw new Error('resume missing');
    const url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
    const download = el('a', BTN, 'Download PDF');
    download.href = url;
    download.download = NAME;
    bar.append(download);
    if ((navigator as Navigator & { pdfViewerEnabled?: boolean }).pdfViewerEnabled === false) {
      // e.g. Chrome on Android, which has no inline PDF viewer
      const big = el('a', BTN + ';font-size:18px;padding:12px 24px', 'Download my resume (PDF)');
      big.href = url;
      big.download = NAME;
      body.replaceChildren(big);
    } else {
      const frame = el('iframe', 'border:0;width:100%;height:100%;background:#fff');
      frame.title = 'Shan Memon resume';
      frame.src = url;
      body.replaceChildren(frame);
      body.style.alignItems = 'stretch';
    }
  } catch {
    body.textContent = 'Sorry, the resume could not be loaded. Please try again later.';
  }
}
